import { IBaseLayoutOptions, IWidgetOption, WidgetType } from '../../../Widget';
import { IInputWidget } from '../IInputWidget';

export enum SingleSelectKind {
  Select = 'select',
  Radio = 'radio',
}

export interface ISingleSelectWidgetLayout extends IBaseLayoutOptions {
  /** Solo per Checkbox/radio */
  direction?: 'horizontal' | 'vertical';
  separator?: 'label' | 'text';
  /** Nascondi etichetta */
  hideLabel?: boolean;
}

export interface ISingleSelectWidget extends IInputWidget {
  type: WidgetType.Select;
  options: IWidgetOption[];
  kind: SingleSelectKind;
  layout?: ISingleSelectWidgetLayout;
}
